export const initMocks = async () => {
  const { worker } = await import('./browser');

  worker.start({
    onUnhandledRequest: 'bypass',
  });
};
